import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, requireRole, ...rest }) => {
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');

  console.log('PrivateRoute Check:', {
    path: rest.path,
    token: !!token,
    userRole,
    requireRole,
    hasRequiredRole: userRole === requireRole
  });

  return (
    <Route
      {...rest}
      render={props => {
        // Not logged in
        if (!token) {
          console.log('No token, redirecting to login');
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
        }

        // No role required, allow access to any authenticated user
        if (!requireRole) {
          console.log('No role required, allowing access');
          return <Component {...props} />;
        }

        // Role required but user doesn't have the correct role
        if (userRole !== requireRole) {
          console.log('Role mismatch:', { userRole, requireRole });
          // Redirect based on user's actual role
          if (userRole === 'operator') {
            console.log('Redirecting operator to dashboard');
            return <Redirect to="/operator/dashboard" />;
          } else if (userRole === 'admin') {
            console.log('Redirecting admin to admin page');
            return <Redirect to="/admin" />;
          } else {
            console.log('Redirecting to home');
            return <Redirect to="/" />;
          }
        }

        // User has the correct role, allow access
        console.log('User has correct role, allowing access');
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;